/** Modulo Auditoria (220) — contracts/enums.yaml */
export const AUDITORIA_ACAO = {
  VER: 2201,
} as const;

export const AUDITORIA_ACOES_MODULO = [AUDITORIA_ACAO.VER] as const;
